<template>
  <form @submit.prevent="$emit('submit')" class="white-box p30">
    <div class="row">
      <div class="col-sm-6">
        <FieldTextInput name="Converter" rules="required" v-model="value.converter" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Address" rules="required" v-model="value.address" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Komoditi" rules="required" v-model="value.commodity" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Aplikasi" rules="required" v-model="value.application" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldSelect name="Status" rules="required" v-model="value.status" :options="statuses" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldTextArea name="Description" rules="required" v-model="value.description" :disabled="disabled" />
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <button v-if="$route.name !== 'AddProspect'" v-permissions="'Delete Prospect'" @click="$emit('on-delete')" class="btn btn-border-red mx-2"
        type="button">Delete</button>
      <button v-permissions="'Create Prospect,Edit Prospect'" v-if="!disabled" class="btn btn-orange" type="submit">Save</button>
    </div>
  </form>
</template>
<script>
import axios from '@/axios';
import FieldSelect from '@/components/field/Select.vue';
import FieldTextInput from '@/components/field/TextInput.vue';
import FieldTextArea from '@/components/field/TextArea.vue';
import { showErrorMessage } from '@/utils';

export default {
  components: {
    FieldTextInput,
    FieldSelect,
    FieldTextArea
  },
  props: ['value', 'disabled'],
  data() {
    return {
      statuses: []
    }
  },
  async mounted() {
    try {
      this.$store.dispatch('toggleLoadingProgress', true)
      const res = await axios.get(`/prospect-status`)
      this.statuses = res?.data?.data?.map(status => ({
        text: status, value: status
      })) ?? []
    } catch (err) {
      showErrorMessage(err)
    } finally {
      this.$store.dispatch('toggleLoadingProgress', false)
    }
  }
}
</script>
